import { CustomImage, errorDialog, Text , useText} from '@src/components';
import iconSuccess from '@src/assets/icons/icon-success.svg';
import iconPrint from '@src/assets/icons/icon-print.svg';
import { Button } from 'antd';
import React, { useCallback, useEffect } from 'react';
import reportsServices from '@src/services/reports.services';
import { useDispatch, useSelector } from 'react-redux';
import '@src/styles/cardOrder/cardCompleted.scss';
import { previewDownload, dataLayer } from '@src/utils/utils';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { getCardOrderForThanksPage } from '@src/store/slice/cardOrderSlice';
import EftWireTransferCards from '@src/pages/ticketRestaurant/balanceUpload/payment/EftWireTransferCards';
import { setPayLaterDayForThanksPage } from '@src/store/slice/mobilExpressSlice';
import { useHistory } from 'react-router-dom';
import { ItemCardImage } from '../balanceUpload/Completed';
import { VouIdCode } from '@src/store/enums';

const Completed = () => {
  const { currentCardOrder, thanksPageCardOrderTextList, cardOrderPopupDigital } = useSelector(
    (state) => state?.cardOrder,
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const cardText = useText('card');

  const directToHomePage = useCallback(() => {
    history.push('/dashboard');
  }, [dispatch]);

  useEffect(async () => {
    if (!currentCardOrder || currentCardOrder.vouId === VouIdCode.Compliments) return;
    await dispatch(getCardOrderForThanksPage({ id: currentCardOrder?.id }));
    await dispatch(setPayLaterDayForThanksPage(null));

    dataLayer(
      'yeni_kart_sipariş',
      currentCardOrder?.CardType === 0 ? 'Fiziksel Kart' : 'Dijital Kart',
      cardOrderPopupDigital ? 'Pop up - Dijital Kart Seçin' : '',
    );
  }, [currentCardOrder]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const printPdf = useCallback(async () => {
    try {
      const blob = await reportsServices.getCardOrderReport({ orderId: currentCardOrder?.id });
      await previewDownload(blob);
    } catch (error) {
      errorDialog({
        title: <Text t="error" />,
        message: error?.statusText,
      });
    }
  }, [currentCardOrder]);

  return (
    <div className="card-order-completed-content">
      <div className="success-order-header-content">
        <CustomImage src={iconSuccess} />
        <h1>{thanksPageCardOrderTextList?.title}</h1>
        {thanksPageCardOrderTextList?.shortMessage && (
          <h5>
            <div
              className="message"
              dangerouslySetInnerHTML={{ __html: thanksPageCardOrderTextList?.shortMessage }}
            />
          </h5>
        )}

        {thanksPageCardOrderTextList?.longMessage && (
          <p
            className={'description-list-long-text'}
            dangerouslySetInnerHTML={{ __html: thanksPageCardOrderTextList?.longMessage }}
          />
        )}

        <div className="description-list">
          {thanksPageCardOrderTextList?.messageList?.map((item, index) => {
            return (
              <p key={item.message}>
                <ItemCardImage item={item} />
                <div
                  className="message-list-item"
                  dangerouslySetInnerHTML={{ __html: item.message }}
                />
              </p>
            );
          })}
        </div>
      </div>
      <div className="footer-content">
        <Button
          id="redirect"
          data-testid="redirect"
          onClick={directToHomePage}
          className="footer-content-button"
        >
          <span>
            <Text t="returnToHomePage" />
          </span>
        </Button>
      </div>

      {thanksPageCardOrderTextList?.ibanShow && (
        <div className="card-order-etfWireTransferCards">
          <EftWireTransferCards type={cardText} finishPage={true} />
        </div>
      )}

      <div className="footer-content">
        <Button id="cardOrders-completed-btn-ghost" className="btn-ghost" onClick={printPdf}>
          <CustomImage src={iconPrint} />
          <span>
            <Text t="orderPrinter" />
          </span>
        </Button>
        <Button
          id="cardOrders-completed-btn-orange"
          className="btn-orange"
          style={{ display: 'none' }}
        >
          <span>
            <Text t="regularInstall" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default Completed;
